<template>
    <div class="table">
        <tr>
            <td>Down payment</td>
            <td class="has-text-right">{{ $store.state.evaluation.calculator.conventionalDownpayment | currency(0) }}</td>
        </tr>
        <tr>
            <td>Closing costs</td>
            <td class="has-text-right">{{ $store.state.evaluation.calculator.conventionalClosingCosts | currency(0) }}</td>
        </tr>
        <tr>
            <td>Prepaid expenses</td>
            <td class="has-text-right">{{ $store.state.evaluation.calculator.conventionalPrepaidExpenses | currency(0) }}</td>
        </tr>
        <tr>
            <td>Repairs</td>
            <td class="has-text-right">{{ $store.state.evaluation.calculator.conventionalRepairsMakeReady | currency(0) }}</td>
        </tr>
        <tr>
            <td class="has-text-weight-semibold">TOTAL</td>
            <td class="has-text-right has-text-weight-semibold">{{ $store.state.evaluation.calculator.conventionalCashOutOfPocketTotal | currency(0) }}</td>
        </tr>
    </div>
</template>

<script>
import store from "@/store";

export default {
  components: {
    store
  }
};
</script>
